<div class="grid grid-cols-2 md:grid-cols-2 xl:grid-cols-4 2xl:grid-cols-6 gap-6">
  @for (item of contentToDisplay; track item.title) {
    <div class="">
      <app-placement-content-card [item]="item"></app-placement-content-card>
    </div>
  }
</div>
